import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {StorageService} from "../../services/storage.service";
import {TaskFilter} from "../../shared/models/task-filter.enum";
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TranslatePipe} from "@ngx-translate/core";
import {MatLabel, MatOption, MatSelect} from "@angular/material/select";
import {MatCheckbox} from "@angular/material/checkbox";
import {MatFormField} from '@angular/material/form-field';
import {MatButton} from "@angular/material/button";


@Component({
    selector: 'app-day-filter',
    templateUrl: './day-filter.component.html',
    imports: [
        TranslatePipe,
        MatFormField,
        MatSelect,
        FormsModule,
        MatOption,
        MatLabel,
        ReactiveFormsModule,
        MatCheckbox,
        MatButton
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./day-filter.component.scss']
})
export class DayFilterComponent implements OnInit {

    filterValues: TaskFilter[] = Object.values(TaskFilter).filter(value => typeof value === 'number');
    selectedFilter: TaskFilter = TaskFilter.All;

    categoryList: string[] = [];
    categoriesSelect = new FormControl<string[]>([], {
        nonNullable: true
    });

    showNeutralTasks: boolean = false;

    constructor(
        private dialogRef: MatDialogRef<DayFilterComponent>,
        private storage: StorageService,
        @Inject(MAT_DIALOG_DATA) public allCategories: string[]
    ) {
        this.categoryList = allCategories;
    }

    ngOnInit() {
        this.initChosenCategories();
        this.initChosenTaskFilter();
        this.initShowNeutral();
    }

    closeFilterDialog(save: boolean) {
        if (save) {
            this.storage.setDayFilterCategories(this.categoriesSelect.value);
            this.storage.setDayFilterTasks(this.selectedFilter);
            this.storage.setDayFilterShowNeutral(this.showNeutralTasks);
        }

        this.dialogRef.close();
    }

    private initChosenCategories() {
        this.categoriesSelect.setValue(this.storage.getDayFilterCategories());
    }

    private initChosenTaskFilter() {
        const savedFilter = this.storage.getDayFilterTasks();

        if (savedFilter) {
            this.selectedFilter = savedFilter;
        }
    }

    private initShowNeutral() {
        this.showNeutralTasks = this.storage.getDayFilterShowNeutral();
    }
}
